import { ReactKit } from '@team/react';
import { Root, Container, Icon, Header, Description, Action } from './entry';

export const Placeholder = ReactKit.createCompoundComponent(Root, {
  Container,
  Icon,
  Header,
  Description,
  Action,
});

Placeholder.displayName = 'Placeholder';
Placeholder.Container.displayName = 'PlaceholderContainer';
Placeholder.Icon.displayName = 'PlaceholderIcon';
Placeholder.Header.displayName = 'PlaceholderHeader';
Placeholder.Description.displayName = 'PlaceholderDescription';
Placeholder.Action.displayName = 'PlaceholderAction';

export type {
  Props as PlaceholderProps,
  ContainerProps as PlaceholderContainerProps,
  IconProps as PlaceholderIconProps,
  HeaderProps as PlaceholderHeaderProps,
  DescriptionProps as PlaceholderDescriptionProps,
  ActionProps as PlaceholderActionProps,
} from './types';
